import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  AdminPasswordResetRequest,
  AuthenticationSuccessDTO,
  CognitoUser,
  Credential,
  PasswordResetRequest,
  PasswordResetTokenStatus,
} from '@cco/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '@app/app.config';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
};

@Injectable()
export class AuthService {
  constructor(@Inject(APP_CONFIG) private config: AppConfig, private http: HttpClient) {}

  getPasswordResetTokenStatus(passwordResetToken: string): Observable<PasswordResetTokenStatus> {
    return this.http.get<PasswordResetTokenStatus>(
      `${this.config.apiBaseUrl}/security/password-reset-token/${encodeURIComponent(
        passwordResetToken,
      )}/status`,
    );
  }

  login({ username, password }: Credential): Observable<CognitoUser> {
    const postBody = new HttpParams().set('username', username).set('password', password);

    return this.http
      .post<AuthenticationSuccessDTO>(
        `${this.config.apiBaseUrl}/authenticate`,
        postBody.toString(),
        httpOptions,
      )
      .pipe(
        map((resp) => {
          // localStorage.setItem('jwt', resp.jwt.token);
          return resp.user;
        }),
      );
  }

  xsrfPing(): Observable<any> {
    return this.http.get<any>(`${this.config.apiBaseUrl}/ping`);
  }

  loginPing(): Observable<CognitoUser> {
    return this.http.get<CognitoUser>(`${this.config.apiBaseUrl}/security/users/current`);
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${this.config.apiBaseUrl}/logout`, {});
  }

  requestAdminPasswordReset(
    userId: number,
    request: AdminPasswordResetRequest,
  ): Observable<string> {
    return this.http.post(`${this.config.apiBaseUrl}/security/users/${userId}/reset-password`, request, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'text',
    });
  }

  resetPassword(passwordResetRequest: PasswordResetRequest): Observable<string> {
    return this.http.post(
      `${this.config.apiBaseUrl}/security/users/reset-password`,
      passwordResetRequest,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        responseType: 'text',
      },
    );
  }
}
